import {
  booleanAttribute,
  Directive,
  ElementRef,
  inject,
  input,
} from '@angular/core';

@Directive({
  selector: '[b2cTrimInput]',
  host: {
    '(input)': 'onInput()',
  },
})
export class TrimInputDirective {
  trimInput = input(true, {
    alias: 'b2cTrimInput',
    transform: booleanAttribute,
  });

  private readonly elementRef: ElementRef<HTMLInputElement> =
    inject(ElementRef);

  onInput(): void {
    if (!this.trimInput()) {
      return;
    }

    const inputElement: HTMLInputElement = this.elementRef.nativeElement;
    inputElement.value = this.trimAndRemoveSpecialChars(inputElement.value);
  }

  /**
   * @param value Input string
   */
  trimAndRemoveSpecialChars(value: string): string {
    return (value || '').trim();
  }
}
